import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { authPasswordFlowConfig } from 'src/app/_services/auth.config';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  requestForm = new FormGroup({
    login: new FormControl('', Validators.required),
    password: new FormControl('', Validators.required),
  });

  constructor(
    private oauthService: OAuthService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.oauthService.configure(authPasswordFlowConfig);
    document.getElementById('requestForm').addEventListener(
      'submit',
      (e: Event) => {
        e.preventDefault();
        if (this.requestForm.valid) {
          // ----------
          const fetchTokenWithTimeout = this.promiseTimeout(10000, this.oauthService.fetchTokenUsingPasswordFlow(this.requestForm.get('login').value, this.requestForm.get('password').value));
          fetchTokenWithTimeout.then(
            result => {
              this.router.navigate(['pages/dashboard']);
            }
          );
        }
      });
  }

  // ===========================================================================
  // ===========================================================================

  get login() { return this.requestForm.get('login'); }
  get password() { return this.requestForm.get('password'); }

  // ===========================================================================
  // ===========================================================================

  private promiseTimeout(ms, promise) {
    // Create a promise that rejects in <ms> milliseconds
    const timeout = new Promise((resolve, reject) => {
      const id = setTimeout(() => {
        clearTimeout(id);
        const error = new Error();
        error.name = 'TimeoutError';
        reject(error);
      }, ms);
    });

    // Returns a race between our timeout and the passed in promise
    return Promise.race([
      promise,
      timeout
    ]);
  }
  // ===========================================================================
  getError(el) {
    switch (el) {
      case 'login':
        if (this.requestForm.get('login').hasError('required')) {
          return 'Login required';
        }
        break;
      case 'password':
        if (this.requestForm.get('password').hasError('required')) {
          return 'Password required';
        }
        break;
      default:
        return '';
    }
  }

}
